module.exports = __webpack_public_path__ + "img/icon-beidou.4f5c6fd7.webp";